import React from 'react';

export interface FormHeaderMetaProps {
  isAnonymousSubmission?: boolean;
  creatorLastName?: string;
  creatorFirstName?: string;
  updatedAt?: string;
}

export const FormHeaderMeta: React.FC<FormHeaderMetaProps> = ({
  isAnonymousSubmission,
  creatorLastName,
  creatorFirstName,
  updatedAt,
}) => (
  <b>
    {isAnonymousSubmission !== true ? (
      <>
        {creatorLastName}, {creatorFirstName?.slice(0, 1)}.{' '}
      </>
    ) : (
      <>Anonymous. </>
    )}
    <>{updatedAt?.toString().toLongDate()}</>
  </b>
);

FormHeaderMeta.displayName = 'FormHeaderMeta';
